// extracted by mini-css-extract-plugin
export default {"genericCard":"Zp-z","inline":"_p-z","mastercard":"aq-z","discover":"bq-z","visa":"cq-z","amex":"dq-z","active":"eq-z"};